import { ImageType } from "next-lib";

type Props = {
  image: ImageType;
};

function GalleryImage({ image }: Props) {
  return (
    <div className="gallery__link">
      <figure className="gallery__thumb">
        <div
          style={{
            backgroundImage: `url(${image.src})`,
          }}
          className="gallery__image"
        />
      </figure>
    </div>
  );
}

export default GalleryImage;
